import React, { useRef } from 'react'

import { useReactToPrint } from 'react-to-print'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem8md10sm12xs12,
    GridItem10sm12xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    IconButtonImprimir
} from '../../../business-components/IconButton/IconButton'

import './EstudoReport.css'



const EstudoReportContainer = ({ values, naoPermitirImprimir, conteudo }) => {

    const componentRef = useRef()

    const handlePrint = useReactToPrint ( {
        content: () => componentRef.current,
    })

    const GridItemContainer = 
        values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
            ?
                GridItem8md10sm12xs12
            :
                GridItem10sm12xs12

    return (
        
        <DivForm
            align="center"
            className={values.modoApresentacao ? '' : 'mt-10'}
        >
            {values.modoApresentacao
                ?
                    <GridContainer>
                        <GridItem12
                            className='mt--5 ml-5 mr-5'
                        >
                            {conteudo}
                        </GridItem12>
                    </GridContainer>
                :
                    <GridItemContainer
                        className='mt-0 bg-estudoReport'
                    >
                        {!naoPermitirImprimir && (
                            <IconButtonImprimir
                                onClick={handlePrint}
                            />
                        )}

                        <div
                            ref={componentRef}
                        >
                            {conteudo}
                        </div>
                    </GridItemContainer>
            }
        </DivForm>
    )
}

export default EstudoReportContainer